module.exports = __webpack_public_path__ + "img/news-08.d2338fd6.jpg";